@if (!inputService.hidden && inputService.formInputDefinition && inputService.control) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field [appearance]='inputService.inputConfig.appearence'>
      <mat-label [matTooltip]='inputService.formInputDefinition.titleTooltip'>
        @if (inputService.exportEAgency) {
          <img matTooltip='Esportato in eAgency' class='title-input-eagency' src='assets/images/logos/logo_eagency.png'/>
        }
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' >{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      <input
        [readonly]='inputService.inputConfig.readOnly'
        [required]='inputService.inputConfig.required'
        [name]='inputService.formControlKey'
        autocomplete="off"
        type='color'
        matInput
        [placeholder]="(inputService.inputConfig.placeholder || '') | translate"
        [formControlName]='inputService.formControlKey'>
      @for (inputIcon of inputService.inputConfig.suffixs; track inputIcon) {
        <mat-icon
          (click)='inputIcon.onClick(inputService.formGroup, inputService.datasetNavigationService)'
          [color]='inputIcon.color' matSuffix>
          {{inputIcon.icon}}
        </mat-icon>
      }
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint | translate}}</mat-hint>
      }
      @if (!inputService.control.valid) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}